import { normalizePhoneNumber } from '@portal/forms';

/**
 * What a phone box should show once the user leaves it: the E.164 form if the typed
 * number can be placed, otherwise exactly what they typed, so the validation message
 * that follows is about the text they can see, not a half-tidied version of it.
 */
export function settledPhone(typed) {
  const normalized = normalizePhoneNumber(typed);
  return /^\+\d+$/.test(normalized) ? normalized : typed;
}
